/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AwardAgreementDocumentCleanupService {

    /**
     * @param zipFileName 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardAgreementDocumentCleanupCleanupZipFileContent(
zipFileName?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-agreement-document-cleanup/cleanup-zip-file-content',
            query: {
                'zipFileName': zipFileName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
